import { useQueryClient } from '@tanstack/react-query';
import {
  UpdateScheduledActionMutation,
  useScheduledActionQuery,
  useUpdateScheduledActionMutation,
} from '../../../../api/gql';

type Props = {
  onSuccess?: (data: UpdateScheduledActionMutation) => void;
  onError?: (status: number) => void;
};

export const useUpdateScheduledAction = (props?: Props) => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useUpdateScheduledActionMutation({
    onSuccess: (data) => {
      queryClient.setQueryData(useScheduledActionQuery.getKey({ id: data.updateScheduledAction.id }), {
        scheduledAction: { ...data.updateScheduledAction },
      });
      props?.onSuccess?.(data);
    },
    onError: (e) => {
      props?.onError?.(e.code);
    },
  });

  return {
    update: mutate,
    isPending,
  };
};
